import axios from 'axios';
import { getBrowserName, getOSName } from '../util/helperFunction';
import store from '../store/store'
import { hideLoader, setError, showLoader } from '../feature/application/appSlice';

const axiosHelper = (headers) => {
  let req = axios.create({
    baseURL: process.env.REACT_APP_SERVER_URL,
    headers: headers
  });

  req.interceptors.request.use(function (request) {
    store.dispatch(showLoader())
    return request;
  });

  req.interceptors.response.use(
    function (response) {
      store.dispatch(hideLoader());
      return response;
    },
    function (error) {
      store.dispatch(setError(error));
      return Promise.reject(error);
    }
  );

  return req;
};

const securedAxios = () => {
  return axiosHelper({
    'Content-type': 'application/json',
    //  Authorization: localStorage.getItem('USER_TOKEN')
  });
};


const unsecuredAxios = () => {
  return axiosHelper({
    'Content-type': 'application/json',
    'broswerName': getBrowserName(),
    'os': getOSName()
  });
};

const api = {
  axiosHelper,
  securedAxios,
  unsecuredAxios,
};

export default api;
